import React, { Component, useState, useEffect } from 'react';
import { Col, Row } from "antd";
import '../components-style.css';
import { Icon } from 'semantic-ui-react';
import {FormattedMessage} from 'react-intl';

//Healthscale img
import sf36_grey from '../../Images/Healthform/health_grey.png';
import sf36_green from '../../Images/Healthform/health_green.png';

class SF36ResDisplay extends Component {

    //Function to display form res alert logo with the good color
    getFormResImg(){
        if(this.props.formresSF36Display.color === "#21BA45"){
            //return green
            return (<img src={sf36_green} style={{ height: "auto", maxHeight: "100%", width: "auto", maxWidth: "55px"}} alt="healthscale_logo"/>)
        }
        else{
            //return grey
            return (<img src={sf36_grey} style={{ height: "auto", maxHeight: "100%", width: "auto", maxWidth: "55px"}} alt="healthscale_logo"/>)
        }
    }

    display_value(){


        let unit = ""

        return(
            <Row style={{ flex:1, flexDirection:'row', alignItems:'center', justifyContent:'center', paddingTop:"5%", paddingBottom:"5%"}}>
                {
                    this.getFormResImg()
                }
            </Row>
        )
    }    

    //Display render
    render(){

        return (
            <div>
                {(this.props.alert) ?
                    <Col style={{backgroundColor: "yellow"}}>
                        {this.display_value()}
                    </Col>
                    :
                    <Col>
                        {this.display_value()}
                    </Col>
                }
            </div>
        );
    }
}
export default (SF36ResDisplay);